/** @format */

import React, { CSSProperties, useState } from "react"
import Button from "@ui-library/core/Button"
import { DownloadRegular } from "@ui-library/icons"
import BFFClient from "_clients/BFFClient"
import { useRelativeRouter } from '../../../shared/hooks/useRelativeRouter'
import { GetQueryValues } from "_shared/helpers/routerHelper"
import { getProductTypeEnumFromId } from "_components/organisms/Dashboard/Dashboard.types"
import FileSaver from "file-saver"

const ButtonExportCsv = () => {
	const router = useRelativeRouter()
	const [downloadInProgress, setDownloadInProgress] = useState<boolean>(false)

	const onClick = () => {
		const query = GetQueryValues(router.asPath)
		setDownloadInProgress(true)
		if(query.networkId){
			BFFClient.getMembersDistributionCsv(
				query.networkId,
				getProductTypeEnumFromId(query.productId),
				query.marketId,
				undefined
			)
				.then(response => {
					FileSaver.saveAs(response.result.data, response.result.fileName)
				})
				.finally(() => {
					setDownloadInProgress(false)
				})
		}
		else {
			BFFClient.getMultiBeneficiariesMembersDistributionCsv(
				query.contractId,
				getProductTypeEnumFromId(query.productId),
				query.marketId,
				undefined
			)
				.then(response => {
					FileSaver.saveAs(response.result.data, response.result.fileName)
				})
				.finally(() => {
					setDownloadInProgress(false)
				})
		}
	}

	const style: CSSProperties = downloadInProgress ? { cursor: "wait" } : {}

	return (
		<Button
			className="btn-space"
			size="medium"
			kind="secondary"
			variant="text"
			icon={DownloadRegular}
			onClick={onClick}
			tag="button"
			disabled={downloadInProgress}
			style={style}
			testID="button-export-csv"
			onPointerEnterCapture={undefined}
			onPointerLeaveCapture={undefined}
		>
			Exporter csv
		</Button>
	)
}

export default ButtonExportCsv
